module.exports = __webpack_public_path__ + "img/deskshelf14.cea1d304.jpg";